import React from 'react';
import { formatAmount, isSafeInputType } from '../utils';
import { inputIndex, inputType } from '../types';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { INSTITUTION_MAP, TYPE_OF_DEBT_MAP } from '../constants';

export const ConfirmedDebtInput = ({
  debt,
  onRemove,
  onEdit,
}: {
  debt: inputType;
  onRemove: (idx: string) => void;
  onEdit: (idx: string) => void;
}) => {
  if (!isSafeInputType(debt)) return null;

  const { index, institution, debt_type } = debt;

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      paddingX={3}
      paddingY={1}
      maxWidth={{ xs: '100%', md: '327px' }}
      marginTop={4}
      sx={(theme) => ({ border: `1px solid ${theme.palette.neutral.light}` })}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        onClick={() => onEdit(index)}
        sx={{ cursor: 'pointer' }}
      >
        <Typography variant="accentSmall">
          {formatAmount(Number(debt[inputIndex.AMOUNT]))}
        </Typography>
        <Box maxWidth={250} paddingLeft="0.75rem" lineHeight="10px">
          <Typography
            variant="bodySmall"
            color="secondary.main"
          >{`${INSTITUTION_MAP[institution]} ${TYPE_OF_DEBT_MAP[debt_type]}`}</Typography>
        </Box>
      </Box>
      <IconButton
        onClick={() => onRemove(index)}
        aria-label="Remove this debt"
        sx={{
          color: 'secondary.main',
          alignSelf: 'center',
        }}
      >
        <CloseIcon sx={{ height: '16px', width: '16px' }} />
      </IconButton>
    </Box>
  );
};
